import { TimePicker } from "antd";
import styles from "./timePickerInput.module.css";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import TextComponent from "../textComponent/TextComponent";
import { GrFormClose } from "react-icons/gr";

const TimePickerInput = ({ inputWidth, label, icon, onChange, value,defaultValue, className, placeholder }) => {
  const { height, width } = useWindowDimensions();
  console.log("rerender picker");

  return (
    <div
      className={`${styles.timePicker} ${className}`}
      style={{ width: width > 576 ? inputWidth : "100%" }}
    >
      {label && (
        <text className={styles.label}>
          <TextComponent>{label}</TextComponent>
        </text>
      )}
      <TimePicker
      placeholder={placeholder ? placeholder : "Select Time"}
        value={value}
        defaultValue={defaultValue}
        use12Hours
        format="hh:mm a"
        onChange={onChange}
        suffixIcon={icon}
        className={styles.timePickerInput}
        inputReadOnly
        clearIcon={
          <div className={styles.clearIconBtn}>
            <GrFormClose
              className={styles.clearIcon}
              style={{ color: "var(--primary-color)" }}
            />
          </div>
        }
      />
    </div>
  );
};

export default TimePickerInput;
